import React,{useState} from "react";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../../components/common/forms/FormPayment";
import MainObjectives from "../../../../../components/common/forms/MainObjectives";
import { upload_document, upload_document_v2 } from "./CompanyObjectChanges";
import { useForm } from "react-hook-form";
import Documents from "../../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import OldCmpObj from "./OldCmpObj";
import NewCmpObj from "./NewCmpObj";
import Option from "../Option";
import BackButton from "../../../../../components/common/backbutton/BackButton";

const CompanyObjectChange = () => {
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);
  const [turnOn, setTurnOn] = useState(true)  



  return (
    <div className="px-10 lg:!px-14">
        <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
          Company Objective Change
        </p>
        <Option setTurnOn={setTurnOn}/>
       
       
          <p className="text-primary-blue font-Calistoga text-lg underline">
            1. Business Name & Other Details
          </p>
       

      { turnOn ?
        <OldCmpObj/>:
        <NewCmpObj/>
}
        {/* new company for 3 months */}
        
       
    </div>
  );
};

export default CompanyObjectChange;
